import React, { FC, ReactNode, useRef } from "react";
import { Box, Flex, IconButton, Link, Popover, PopoverContent, PopoverTrigger, Text, Button, Stack, Collapse, Icon, useBreakpointValue, useColorModeValue, useDisclosure, Container, useColorMode, Menu, MenuButton, MenuList, Center, Avatar, MenuDivider, MenuItem, Spacer, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter, SimpleGrid, Tag } from "@chakra-ui/react";

import { FiArrowLeftCircle } from 'react-icons/fi';
import { useNavigate } from "react-router-dom";

type LayoutProps = {
    children: ReactNode,
    title: string,
    backUrl: string,
    subtitle?: string
};

const LayoutProgramLesson: FC<LayoutProps> = ({ children, title, subtitle, backUrl }) => {
    const navigate = useNavigate();

    return (
        <Box backgroundColor={"whiteAlpha.800"} minH={'100vh'}>
            <Container maxWidth={"7xl"} pt={3}>
                <Box as="header">
                    <Flex alignItems={"center"}>
                        <Box>
                            <Link onClick={() => navigate(backUrl)} color={"gray.900"}  >
                                <FiArrowLeftCircle size={'2em'} />
                            </Link>
                        </Box>
                        <Spacer />
                        <Box textAlign={"center"} color={"gray.900"}>
                            <Text fontSize={'md'} fontWeight={"bold"}>{title}</Text>
                            <Text fontSize={'xs'} fontWeight={"normal"}>{subtitle}</Text>
                        </Box>
                        <Spacer />
                        <Box></Box>
                    </Flex>
                </Box>
                <Box as="main" mt={10}>
                    {children}
                </Box>
            </Container>
        </Box>
    );
};

export default LayoutProgramLesson;